<app-aumico-layout [hideFooter]="true">
    <ng-container header>
        <ham-page-header
            [title]="'aumico_reports_main_navigation_tasks' | i18next"
            [hasBackButton]="false"
        ></ham-page-header>
        <div class="filters-container">
            <div class="search-wrapper">
                <ham-filter
                    [value]="tasksFilter?.taskName || ''"
                    [placeholder]="'aumico_tasks_overview_search_tasks' | i18next"
                    [hasFilterButton]="false"
                    (filter)="onSearchFilterChange($event)"
                ></ham-filter>
            </div>
            <div class="button-filters-wrapper">
                <date-filter-drop-down
                    translationKeyFilterName="aumico_pm_tasks_due_date_filter_label"
                    [multiSelect]="true"
                    [selectedDates]="tasksFilter?.dateRange || []"
                    (filterChangeMulti)="onDueDateFilterChangeMulti($event)"
                ></date-filter-drop-down>

                <company-filter-drop-down
                    data-testid="tasks-filter-mandant"
                    labelKey="aumico_tasks_col_mandant"
                    [companies]="searchedCompaniesOptions"
                    [selectedCompanyIds]="selectedMandantIds"
                    (companyChange)="onCompanyFilterChange($event)"
                    (searchChange)="onSearchFilterChangeCompanies($event)"
                >
                </company-filter-drop-down>

                <user-filter-drop-down
                    [users]="searchedAssigneeOptions"
                    [selectedUserIds]="tasksFilter?.assignedTo || []"
                    [currentUserId]="activeUserAumicoInternalId"
                    (userChange)="onAssigneeFilterChange($event)"
                    (searchChange)="onSearchFilterChangeAssignee($event)"
                    label="aumico_tasks_overview_filter_assignee_label"
                ></user-filter-drop-down>

                <status-filter-drop-down
                    [rightAlignment]="true"
                    [selectedStatus]="tasksFilter && tasksFilter.taskStates ? tasksFilter.taskStates : []"
                    (statusChange)="onTaskStateFilterChange($event)"
                ></status-filter-drop-down>
                <!-- REV-22155: filter "Typ" next to "Status", same look -->
                <subject-type-filter-drop-down
                    data-testid="tasks-filter-type"
                    [rightAlignment]="true"
                    [selectedTypes]="tasksFilter?.subjectTypes || []"
                    (typeChange)="onSubjectTypeFilterChange($event)"
                ></subject-type-filter-drop-down>
                <div class="divider"></div>
                <ham-button
                    size="base"
                    variant="primary"
                    outline="true"
                    (click)="exportTasksExcel()"
                    icon="assets/hamIcons/file-export-outline.svg"
                >
                    <span style="padding: 4px">{{ 'aumico_ui_export' | i18next }}</span>
                </ham-button>
            </div>
        </div>
    </ng-container>

    <ng-container content>
        <!-- Scrollable wrapper -->
        <div class="table-wrapper">
            <pm-tasks-overview-table
                [anyActiveFilter]="isAnyFilterActive()"
                [data]="tasksOverviewTableData"
                [assigneeOptions]="assigneeOptions"
                [activeSortBy]="tasksFilter?.sortBy || null"
                [activeSortOrder]="tasksFilter?.sortOrder || null"
                [selectedTaskIds]="selectedTasksForBulkActions"
                [selectAllToggled]="selectAllToggled"
                (updateTask)="updateTask($event)"
                (sortTasks)="sortTasks($event)"
                (addProject)="addProject()"
                (onTaskClicked)="onTaskClicked($event)"
                (toggleSelectAll)="onToggleSelectAll()"
                (toggleSelectTask)="onToggleSelectTask($event)"
            ></pm-tasks-overview-table>
        </div>
    </ng-container>
</app-aumico-layout>

<ham-modal
    *ngIf="showCreateProjectPopup"
    class="feedback"
    [hideFooter]="true"
    [showCancelButton]="'false'"
    hideHeader="true"
>
    <new-project-wizard
        [cpmmIsActive]="isCpmmActive"
        [companiesList]="companiesList"
        [balanceSheetDate]="balanceSheetDate"
        (selectedCompany)="onCompanySelected($event)"
        (selectedBalanceSheetDate)="onBalanceSheetDateSelected($event)"
        (selectedReportType)="onReportTypeSelected($event)"
        (selectedMandateManagementWorkflow)="onMandateManagementWorkflowSelected($event)"
        (selectedClosingWorkflow)="onClosingWorkflowSelected($event)"
        (closeButtonClicked)="closeNewProjectDialog($event)"
    ></new-project-wizard>
</ham-modal>
<app-loading-spinner [active]="isCreatingAnnualReport"></app-loading-spinner>

<!-- Bulk Edit action bar -->
<bulk-edit-action-bar
    *ngIf="selectedTasksForBulkActions?.size > 0"
    [selectedCount]="selectedTasksForBulkActions?.size"
    [actions]="bulkActions"
    [deleteAction]="deleteAction"
    textSelectedTranslationKey="aumico_companies_bulk_edit_action_bar_selected_text"
    [globalPosition]="true"
    (actionClicked)="onActionClicked($event)"
></bulk-edit-action-bar>

<!-- Ham Modal for Bulk Edit Status -->
<ham-modal
    *ngIf="openBulkEditStatus"
    [title]="'aumico_tasks_overview_bulk_edit_status_title' | i18next : { count: selectedTasksForBulkActions.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditStatus = false"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditStatusConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_tasks_overview_bulk_edit_status_label' | i18next"
        [options]="possibleStatus"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_tasks_overview_bulk_edit_status_placeholder' | i18next"
        [formControl]="bulkEditStatusControl"
/></ham-modal>

<!-- Ham Modal for Assignee Change -->
<ham-modal
    *ngIf="openBulkEditAssignee"
    [title]="'aumico_tasks_overview_bulk_edit_assignee_title' | i18next : { count: selectedTasksForBulkActions.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditAssignee = false"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditAssigneeConfirm()"
    ><input
        hamSimpleDropDown
        [label]="'aumico_tasks_overview_bulk_edit_assignee_label' | i18next"
        [options]="assigneeOptions"
        [optionKeys]="['name']"
        returnKey="id"
        [returnObject]="true"
        [placeholder]="'aumico_tasks_overview_bulk_edit_assignee_placeholder' | i18next"
        [formControl]="bulkEditAssigneeControl"
/></ham-modal>

<!-- HamModal for Due Date Change -->
<ham-modal
    *ngIf="openBulkEditDueDate"
    [title]="'aumico_tasks_overview_bulk_edit_due_date_title' | i18next : { count: selectedTasksForBulkActions.size }"
    [cancelText]="'aumico_button_cancel' | i18next"
    [showCancelButton]="true"
    (cancel)="openBulkEditDueDate = false"
    [saveText]="'aumico_button_save' | i18next"
    (save)="onEditDueDateConfirm()"
    [size]="'xs'"
>
    <div class="custom-datepicker-wrapper">
        <mat-calendar
            [selected]="bulkEditDueDateControl.value"
            (selectedChange)="bulkEditDueDate($event)"
        ></mat-calendar>
    </div>
</ham-modal>

<!-- HamModal for Bulk Delete -->
<ham-confirm-decline-modal
    *ngIf="openBulkDeleteConfirmationDialog"
    (cancel)="cancelDeleteBulkTasks()"
    (action)="confirmDeleteBulkTasks()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_button_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_button_cancel' | i18next }}"
>
    <ham-general-confirm-decline-modal-body
        [text]="'aumico_app_cpmm_tasks_delete_confirmation' | i18next : { count: selectedTasksForBulkActions.size }"
    ></ham-general-confirm-decline-modal-body>
</ham-confirm-decline-modal>
